export default "__VITE_ASSET__02e30737__"